<template>
  <el-dialog
    class="rc-dialog"
    :title="curdTitle"
    :visible.sync="CUFlag"
    v-if="CUFlag"
    @close="loseDialog"
    :close-on-click-modal="false"
  >
    <el-form
      ref="curdForm"
      :size="size"
      :rules="rules"
      :model="curdForm"
      label-position="right"
      :label-width="[editType ? '140px' : '100px']"
    >
      <el-row :gutter="12" v-if="!editType">
        <el-col :span="22">
          <el-form-item label="适用组织" prop="deptId" required>
            <el-select
              v-model="curdForm.deptId"
              placeholder="请选择适用组织"
              style="width:100%;"
            >
              <el-option
                v-for="(item, i) in deptList"
                :key="i"
                :label="item.deptName"
                :value="item.uuid"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="22">
          <el-form-item label="学分资源类型" prop="resourceType" required>
            <el-select
              v-model="curdForm.resourceType"
              placeholder="请选择学分资源类型"
              style="width:100%;"
            >
              <el-option
                v-for="(item, i) in resourceTypeList"
                :key="i"
                :label="item.paramValue"
                :value="item.paramKey"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="12" class="main-contant" v-else-if="editType == 'video'">
        <el-col>
          <div class="flex-row">
            <div class="blue-line"></div>
            <p>30分钟以内视频</p>
          </div>
          <div class="input-wrap">
            每<el-input
              type="number"
              min="0"
              size="small"
              v-model="creditRuleDetails[0].ruleValue"
            ></el-input
            >分钟获得学分
            <el-input
              type="number"
              min="0"
              size="small"
              v-model="creditRuleDetails[1].ruleValue"
            ></el-input
            >分
          </div>
        </el-col>
        <el-col>
          <div class="flex-row m-t-12">
            <div class="blue-line"></div>
            <p>30分钟(含)以上视频</p>
          </div>
          <div class="input-wrap">
            每<el-input
              type="number"
              min="0"
              size="small"
              v-model="creditRuleDetails[2].ruleValue"
            ></el-input
            >分钟获得学分
            <el-input
              size="small"
              type="number"
              min="0"
              v-model="creditRuleDetails[3].ruleValue"
            ></el-input
            >分, 上限
            <el-input
              size="small"
              type="number"
              min="0"
              v-model="creditRuleDetails[4].ruleValue"
            ></el-input>
          </div>
        </el-col>
      </el-row>
      <el-row
        :gutter="12"
        class="main-contant m-t-12"
        v-else-if="editType == 'article'"
      >
        <el-col>
          <el-form-item label="得分篇数上线配置：" required>
            <el-input-number
              v-model="creditRuleDetails[0].ruleValue"
              :min="0"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="每篇文章学分：" required>
            <el-input-number
              v-model="creditRuleDetails[1].ruleValue"
              :min="0"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="12" class="main-contant" v-else-if="editType == 'book'">
        <Table :data="creditRuleDetails" />
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn title="取消" @click.native="closeFrom('curdForm')"></butn>
      <butn btntype="primary" title="确定" @click.native="createData"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import Bus from "./Bus.js";
import { topDeptList } from "@/api/dept";
import {
  creditRuleSave,
  creditRuleUpdate,
  creditRuleInfo
} from "@/api/creditRule";
import { getSysParamByTypes } from "@/api/sysParam";
import Table from "./bookTable.js";

export default {
  components: { butn, Table },
  data() {
    return {
      resourceTypeList: [],
      booksTypeList: [],
      deptList: [],
      deptName: "",
      size: "small",
      curdTitle: "",
      CUFlag: false,
      Dflag: false,
      curdForm: {},
      rules: {
        resourceType: [{ required: true, message: "学分类型不能为空" }],
        deptId: [{ required: true, message: "所属学院不能为空" }]
      },
      editType: "",
      editUuid: "",
      ruleStatus: 0,
      creditRuleDetails: [],
      command: function() {}
    };
  },
  watch: {},
  created() {
    var _this = this;
    _this.getSysParamByTypes(["CREDIT_RESOURCE_TYPE", "ARTICLE_TYPE"]);
    topDeptList().then(res => {
      if (!res || res.code != 0) return;
      this.deptList = res.data;
    });
    Bus.$on("ReceiveMessage", function(item) {
      _this.$nextTick(() => {
        _this.curdTitle = item == "" ? "新增学分规则" : "编辑学分规则";
        _this.editType = item.type || "";
        _this.editUuid = item.id || "";
        if (item) {
          _this.getDetail();
        } else {
          _this.curdForm = {};
        }
        _this.command = creditRuleSave;
        _this.CUFlag = true;
      });
    });
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({types: types}).then((res) => {
        if (!res || res.code != 0) return;
        this.resourceTypeList = res.data["CREDIT_RESOURCE_TYPE"] || [];
        this.booksTypeList = res.data["ARTICLE_TYPE"] || [];
      });
    },
    // 详情接口
    getDetail() {
      creditRuleInfo(this.editUuid).then(res => {
        if (!res || res.code != 0) return;
        this.creditRuleDetails = res.data.creditRuleDetails;
        // 图书类型，重新组装数据
        if (this.editType == "book") {
          this.creditRuleDetails.forEach(elem => {
            for (let i = 0; i < this.booksTypeList.length; i++) {
              if (elem.ruleKey == this.booksTypeList[i].paramKey) {
                elem.typeName = this.booksTypeList[i].paramValue;
                elem.ruleKey = this.booksTypeList[i].paramKey;
              }
            }
          });
        }
      });
    },
    createData() {
      this.$refs.curdForm.validate(valid => {
        if (valid) {
          if (!this.editUuid) {
            this.loading = true;
            this.curdForm.ruleStatus = this.ruleStatus;
            const params = Object.assign({}, this.curdForm);
            this.command(params)
              .then(res => {
                if (!res || res.code != 0) throw new Error(res.msg);
                this.$message.success(res.msg);
                this.$emit("search", {});
                this.CUFlag = false;
              })
              .finally(() => (this.loading = false));
          } else {
            this.curdForm.creditRuleDetails = this.creditRuleDetails;
            creditRuleUpdate(this.curdForm).then(res => {
              if (!res || res.code != 0) {
                this.$refs["curdForm"].resetFields();
                throw new Error(res.msg);
              }
              this.CUFlag = false;
              this.$message.success(res.msg);
              this.$refs["curdForm"].resetFields();
            });
          }
        }
      });
    },
    closeFrom(curdForm) {
      this.CUFlag = false;
      // 点击取消 数据重置
      this.$refs[curdForm].resetFields();
    },
    loseDialog() {
      this.CUFlag = false;
      // 点击取消 数据重置
      this.$refs["curdForm"].resetFields();
    }
  },
  destroyed() {
    Bus.$off("ReceiveMessage");
  }
};
</script>

<style lang="scss" scoped>
.main-contant {
  padding: 0 16px;
}
.m-t-12 {
  margin-top: 12px;
}
.flex-row {
  display: flex;
  align-items: center;
  color: #343c4a;
}
.input-wrap {
  color: #526078;
  font-size: 12px;
  .el-input {
    margin: 0 8px;
    width: 64px;
  }
}
.blue-line {
  background-color: #3a85ff;
  height: 14px;
  width: 3px;
  margin-right: 6px;
}
</style>
